const infoContactUs = {
  nhsEmail: "clientsupport@healthbeacon.com",
  nhsPhoneNumber: "+44 (0) 203 936 8807",
};
export default infoContactUs;
